(function () {
    'use strict';

    var SCROLL_OFFSET = 150;

    function normalizePath(path) {
        path = path || '/';
        if (path.charAt(0) !== '/') path = '/' + path;
        // bỏ trailing slash để so sánh /co-dong với /co-dong/ là như nhau
        if (path.length > 1 && path.charAt(path.length - 1) === '/') {
            path = path.slice(0, -1);
        }
        return path;
    }

    function scrollToHash(hash) {
        if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return false;
        var target;
        try {
            target = document.querySelector(hash);
        } catch (e) {
            return false;
        }
        if (!target) return false;
        var top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
        return true;
    }

    function closeOxyModal() {
        var closeBtn = document.querySelector('.oxy-close-modal');
        if (closeBtn) closeBtn.click();
    }

    // Bắt tất cả link có hash, không giới hạn path cụ thể.
    document.addEventListener('click', function (e) {
        var anchor = e.target.closest ? e.target.closest('a') : null;
        if (!anchor || !anchor.hash) return;
        if (anchor.host !== window.location.host) return;

        var samePage = normalizePath(anchor.pathname) === normalizePath(window.location.pathname);
        if (!samePage) {
            // khác trang -> đóng modal trước khi browser điều hướng
            if (anchor.closest('.ct-modal')) closeOxyModal();
            return;
        }

        e.preventDefault();

        var inModal = !!anchor.closest('.ct-modal');
        if (inModal) closeOxyModal();

        var hash = anchor.hash;
        setTimeout(function () {
            scrollToHash(hash);
            if (history.replaceState) {
                history.replaceState(null, '', hash);
            }
            if (inModal) {
                setTimeout(function () { scrollToHash(hash); }, 200);
            }
        }, inModal ? 450 : 0);
    });

    function handleInitialHash() {
        if (!window.location.hash) return;
        setTimeout(function () {
            scrollToHash(window.location.hash);
        }, 100);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleInitialHash);
    } else {
        handleInitialHash();
    }

    window.addEventListener('hashchange', function () {
        scrollToHash(window.location.hash);
    });
})();

// ==============================================
// Stack Section — Scroll Animation
// ==============================================
(function() {
    'use strict';

    if (window.cmOxygenBuilder || window.cmStackAnimationInitialized) {
        return;
    }
    window.cmStackAnimationInitialized = true;

    function initStackAnimation() {
        var stackItems = document.querySelectorAll('.section__stack .stack__item');
        if (!stackItems.length) return;

        // CRITICAL: Force overflow:visible on ALL ancestors of .stack__container
        // position:sticky WILL NOT WORK if any parent has overflow hidden/auto/scroll
        var containers = document.querySelectorAll('.stack__container');
        containers.forEach(function(container) {
            var el = container.parentElement;
            while (el && el !== document.documentElement) {
                var cs = window.getComputedStyle(el);
                var ov = cs.overflow;
                var ovx = cs.overflowX;
                var ovy = cs.overflowY;
                if (el.tagName !== 'BODY' && el.tagName !== 'HTML') {
                    if (ov === 'hidden' || ov === 'auto' || ov === 'scroll' ||
                        ovx === 'hidden' || ovy === 'hidden') {
                        el.style.overflow = 'visible';
                        el.style.overflowX = 'visible';
                        el.style.overflowY = 'visible';
                    }
                }
                el = el.parentElement;
            }
        });

        // IntersectionObserver to reveal items on scroll
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.remove('hide');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                root: null,
                rootMargin: '0px 0px -10% 0px',
                threshold: 0.1
            });

            stackItems.forEach(function(item) {
                observer.observe(item);
            });
        } else {
            // Fallback: show all
            stackItems.forEach(function(item) {
                item.classList.remove('hide');
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStackAnimation);
    } else {
        initStackAnimation();
    }
})();

// ==============================================
// Section Stack Item — class-based sticky stacking
// Apply .section-stack-item to any sibling sections
// ==============================================
(function() {
    'use strict';

    if (window.cmOxygenBuilder || window.cmSectionStackInitialized) {
        return;
    }
    window.cmSectionStackInitialized = true;

    function initSectionStack() {
        // Oxygen builder: never wrap sections in a group div, it breaks the
        // builder's component tree and selection. Sticky is disabled there via CSS.
        if (document.body && document.body.classList.contains('oxygen-builder-body')) {
            return;
        }

        var items = document.querySelectorAll('.section-stack-item');
        if (!items.length) return;

        // Group runs of consecutive sibling items; each run stacks independently
        var groups = [];
        var current = null;
        items.forEach(function(item) {
            if (current && current.parent === item.parentElement &&
                current.items[current.items.length - 1] === item.previousElementSibling) {
                current.items.push(item);
            } else {
                current = { parent: item.parentElement, items: [item] };
                groups.push(current);
            }
        });

        // CRITICAL: wrap each run in a bounding container so the sticky range
        // ends with the group — otherwise items stay stuck for the rest of the
        // parent and overlap every section that follows them
        groups.forEach(function(group) {
            if (!group.parent.classList.contains('section-stack-group')) {
                var wrapper = document.createElement('div');
                wrapper.className = 'section-stack-group';
                group.parent.insertBefore(wrapper, group.items[0]);
                group.items.forEach(function(item) {
                    wrapper.appendChild(item);
                });
            }
            group.items.forEach(function(item, i) {
                item.style.setProperty('--stack-order', i + 1);
            });
        });

        // CRITICAL: position:sticky breaks if any ancestor clips overflow
        items.forEach(function(item) {
            var el = item.parentElement;
            while (el && el !== document.documentElement) {
                if (el.tagName !== 'BODY') {
                    var cs = window.getComputedStyle(el);
                    if (cs.overflow === 'hidden' || cs.overflow === 'auto' || cs.overflow === 'scroll' ||
                        cs.overflowX === 'hidden' || cs.overflowY === 'hidden') {
                        el.style.overflow = 'visible';
                        el.style.overflowX = 'visible';
                        el.style.overflowY = 'visible';
                    }
                }
                el = el.parentElement;
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSectionStack);
    } else {
        initSectionStack();
    }
})();
// ==============================================
// News Page — Featured Slider + Sort & Pagination (AJAX)
// ==============================================
(function($) {
    'use strict';

    if (window.cmOxygenBuilder) return;

    var svgDotDefault = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12" height="12" fill="#C9C9C9"/></svg>';
    var svgDotActive = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12" height="12" fill="#FF2D55"/></svg>';

    function updateDots($slider) {
        $slider.find('.slick-dots li').each(function() {
            var $li = jQuery(this);
            var $btn = $li.find('button');
            if ($li.hasClass('slick-active')) {
                $btn.html(svgDotActive);
            } else {
                $btn.html(svgDotDefault);
            }
        });
    }

    var NEWS_LIST_URL_KEY = 'cmNewsListUrl';

    function saveNewsListUrl() {
        try {
            sessionStorage.setItem(NEWS_LIST_URL_KEY, window.location.pathname + window.location.search);
        } catch (e) {}
    }

    function trimSlash(path) {
        return String(path || '').replace(/\/+$/, '');
    }

    // On non-list pages (e.g. single post), rewrite plain links pointing to the
    // news list page (e.g. the "<-" back link) so they carry the last used
    // filter / sort / page params. Menu links in header/footer/nav are skipped.
    function initNewsBackLinks() {
        var saved = '';
        try {
            saved = sessionStorage.getItem(NEWS_LIST_URL_KEY) || '';
        } catch (e) {
            return;
        }
        if (!saved || saved.indexOf('?') === -1) return;

        var savedPath = trimSlash(saved.split('?')[0]);
        if (trimSlash(window.location.pathname) === savedPath) return;

        $('a[href]').each(function() {
            var href = this.getAttribute('href');
            if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return;

            var url = document.createElement('a');
            url.href = href;

            if (url.host && url.host !== window.location.host) return;
            if (url.search) return;
            if (trimSlash(url.pathname) !== savedPath) return;
            if ($(this).closest('header, footer, nav, .oxy-nav-menu, .oxy-header, .menu').length) return;

            this.setAttribute('href', saved + (url.hash || ''));
        });
    }

    function initNewsPage() {
        var $sort = $('.news-sort');
        var $list = $('.news-list');
        var $featured = $('.news-featured');

        if (!$sort.length && !$list.length && !$featured.length) return;

        if ($featured.length && $featured.find('.news-featured__slider').length) {
            $featured.find('.news-featured__slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 5000
            });

            $featured.find('.news-featured__slider').each(function() {
                var $slider = $(this);
                updateDots($slider);
                $slider.on('afterChange', function() {
                    updateDots($slider);
                });
            });
        }

        if (!$list.length) return;
        if (typeof cmNewsAjax === 'undefined') return;

        var urlParams = new URLSearchParams(window.location.search);
        var postsPerPage = $list.data('posts-per-page') || 10;
        var featuredIds = String($list.data('featured-ids') || '').split(',').filter(Boolean);
        var currentOrder = $sort.find('.news-sort__btn.is-active').data('sort') || 'newest';
        var currentPage = Math.max(1, parseInt(urlParams.get('pg'), 10) || 1);
        var currentCategory = $list.data('current-category') || $('.news-category-filter__btn.is-active').data('category') || '';

        // Persist filter state in the URL (without adding history entries)
        // so that navigating back to this page restores the active filter.
        function updateUrlState() {
            if (!window.history || !window.history.replaceState) return;

            var params = new URLSearchParams(window.location.search);

            if (currentCategory) {
                params.set('news_cat', currentCategory);
            } else {
                params.delete('news_cat');
            }

            if (currentOrder === 'oldest') {
                params.set('sort', 'oldest');
            } else {
                params.delete('sort');
            }

            if (currentPage > 1) {
                params.set('pg', currentPage);
            } else {
                params.delete('pg');
            }

            var query = params.toString();
            var newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
            window.history.replaceState(window.history.state, '', newUrl);
            saveNewsListUrl();
        }

        // Remember the list URL (with filters) so that "back" links on the
        // detail page can restore the active filter (see initNewsBackLinks).
        saveNewsListUrl();

        $sort.on('click', '.news-sort__btn', function() {
            var $btn = $(this);
            if ($btn.hasClass('is-active')) return;

            $sort.find('.news-sort__btn').removeClass('is-active');
            $btn.addClass('is-active');
            currentOrder = $btn.data('sort');
            currentPage = 1;
            updateUrlState();
            loadPosts();
        });

        $(document).on('click', '.news-category-filter__btn', function() {
            var $btn = $(this);
            if ($btn.hasClass('is-active')) return;

            $('.news-category-filter__btn').removeClass('is-active');
            $btn.addClass('is-active');
            currentCategory = $btn.data('category') || '';
            currentPage = 1;
            updateUrlState();
            loadPosts();
        });

        $(document).on('click', '.news-pagination__arrow--prev, .news-pagination__arrow--next', function() {
            var $btn = $(this);
            if ($btn.prop('disabled')) return;

            currentPage = parseInt($btn.data('page'), 10);
            updateUrlState();
            loadPosts();
        });

        function loadPosts() {
            var $grid = $('#news-all-grid');
            var $pagination = $('#news-pagination');

            $grid.css('opacity', '0.5');

            $.ajax({
                url: cmNewsAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'cm_news_load_posts',
                    nonce: cmNewsAjax.nonce,
                    page: currentPage,
                    order: currentOrder,
                    posts_per_page: postsPerPage,
                    featured_ids: featuredIds,
                    category: currentCategory
                },
                success: function(response) {
                    if (response.success) {
                        $grid.html(response.data.posts).css('opacity', '1');
                        $pagination.html(response.data.pagination);
                        currentPage = response.data.page;

                        $('html, body').animate({
                                    scrollTop: $list.offset().top - 100
                                }, 500);
                    }
                },
                error: function() {
                    $grid.css('opacity', '1');
                }
            });
        }
    }

    $(document).ready(initNewsPage);
    $(document).ready(initNewsBackLinks);
})(jQuery);


// Init slide-gallery-sector
(function($) {
    function initGallerySectorSlider() {
        var $slider = $('.slide-gallery-sector');
        if (!$slider.length || typeof $.fn.slick !== 'function') return;

        $slider.each(function() {
            var $currentSlider = $(this);
            if ($currentSlider.hasClass('slick-initialized') || !$currentSlider.children().length) return;

            $currentSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 5000
            });
        });
    }

    window.cmInitGallerySectorSlider = initGallerySectorSlider;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGallerySectorSlider);
    } else {
        initGallerySectorSlider();
    }

    document.addEventListener('oxygenVSBInitTabsJs', initGallerySectorSlider);
})(jQuery);

// ==============================================
// Decorative Lines — Scroll Reveal
// ==============================================
(function() {
    'use strict';

    // Must match breakpoints in assets/scss/components/_line-animation.scss
    var MOBILE_MAX_WIDTH = 767;
    var TABLET_MIN_WIDTH = 768;
    var TABLET_MAX_WIDTH = 1024;
    var MOBILE_QUERY = '(max-width: ' + MOBILE_MAX_WIDTH + 'px)';
    var TABLET_QUERY = '(min-width: ' + TABLET_MIN_WIDTH + 'px) and (max-width: ' + TABLET_MAX_WIDTH + 'px)';
    var LINE_SELECTOR = [
        '.line-top',
        '.line-right',
        '.line-bottom',
        '.line-left',
        '.line-top-mobile',
        '.line-right-mobile',
        '.line-bottom-mobile',
        '.line-left-mobile',
        '.line-top-tablet',
        '.line-right-tablet',
        '.line-bottom-tablet',
        '.line-left-tablet'
    ].join(', ');

    function getLineVar(line, name) {
        return window.getComputedStyle(line).getPropertyValue(name).trim();
    }

    function hasCustomLength(line, name) {
        var value = getLineVar(line, name);
        return value && value !== 'auto' && value !== '0';
    }

    function setDotVar(line, name, value) {
        line.style.setProperty(name, value);
    }

    function clearDotVars(line) {
        [
            '--dot-top',
            '--dot-right',
            '--dot-bottom',
            '--dot-left',
            '--dot-x',
            '--dot-y'
        ].forEach(function(name) {
            line.style.removeProperty(name);
        });
    }

    function getDirectionBySuffix(line, suffix) {
        if (line.classList.contains('line-top' + suffix)) return 'top';
        if (line.classList.contains('line-bottom' + suffix)) return 'bottom';
        if (line.classList.contains('line-left' + suffix)) return 'left';
        if (line.classList.contains('line-right' + suffix)) return 'right';
        return null;
    }

    function getActiveLineDirection(line) {
        // Mobile: only -mobile classes are active (desktop lines are hidden in CSS).
        if (window.matchMedia(MOBILE_QUERY).matches) {
            return getDirectionBySuffix(line, '-mobile');
        }

        // Tablet: -tablet class wins; without one, fall back to the desktop line.
        if (window.matchMedia(TABLET_QUERY).matches) {
            var tabletDirection = getDirectionBySuffix(line, '-tablet');
            if (tabletDirection) return tabletDirection;
        }

        return getDirectionBySuffix(line, '');
    }

    function applyLineSettings(line) {
        clearDotVars(line);

        // Keep .line-has-dot on re-apply so the dot does not re-run its
        // reveal transition (scale 0 -> 1) every time settings are refreshed.
        var side = setLineDotPosition(line);
        if (!side) {
            line.classList.remove('line-has-dot');
            return;
        }

        requestAnimationFrame(function() {
            alignDotToRenderedLine(line, side);
        });
    }

    function setLineDotPosition(line) {
        var direction = getActiveLineDirection(line);
        if (!direction) return null;

        var dots = getLineVar(line, '--dots');
        if (!dots || dots === 'none' || dots === '0' || dots === 'false') return null;

        var dotSides = dots.split(/\s+/).filter(Boolean);
        var isTop = direction === 'top';
        var isBottom = direction === 'bottom';
        var isLeft = direction === 'left';
        var isRight = direction === 'right';

        if (dotSides.indexOf('start') !== -1) {
            dotSides.push(isTop || isBottom ? 'left' : 'top');
        }

        if (dotSides.indexOf('end') !== -1) {
            dotSides.push(isTop || isBottom ? 'right' : 'bottom');
        }

        var side = dotSides[0];
        if (side === 'start' || side === 'end') side = dotSides[1];
        if (!side) return null;

        line.classList.add('line-has-dot');

        if (isTop || isBottom) {
            setDotVar(line, isBottom ? '--dot-bottom' : '--dot-top', isBottom ? 'var(--bottom, 0)' : 'var(--top, 0)');
            setDotVar(line, '--dot-y', isBottom ? '50%' : '-50%');
        }

        if (isLeft || isRight) {
            setDotVar(line, isRight ? '--dot-right' : '--dot-left', isRight ? 'var(--right, 0)' : 'var(--left, 0)');
            setDotVar(line, '--dot-x', isRight ? '50%' : '-50%');
        }

        if (side === 'top') {
            setDotVar(line, '--dot-top', 'var(--top, 0)');
            setDotVar(line, '--dot-y', '-50%');
        } else if (side === 'right') {
            if ((isTop || isBottom) && hasCustomLength(line, '--width')) {
                setDotVar(line, '--dot-left', 'calc(var(--left, 0px) + var(--width))');
                setDotVar(line, '--dot-right', 'auto');
                setDotVar(line, '--dot-x', '-50%');
            } else {
                setDotVar(line, '--dot-right', 'var(--right, 0)');
                setDotVar(line, '--dot-x', '50%');
            }
        } else if (side === 'bottom') {
            if ((isLeft || isRight) && hasCustomLength(line, '--height')) {
                setDotVar(line, '--dot-top', 'calc(var(--top, 0px) + var(--height))');
                setDotVar(line, '--dot-bottom', 'auto');
                setDotVar(line, '--dot-y', '-50%');
            } else {
                setDotVar(line, '--dot-bottom', 'var(--bottom, 0)');
                setDotVar(line, '--dot-y', '50%');
            }
        } else if (side === 'left') {
            setDotVar(line, '--dot-left', 'var(--left, 0)');
            setDotVar(line, '--dot-x', '-50%');
        }

        return side;
    }

    function alignDotToRenderedLine(line, side) {
        if (!line.isConnected || !line.classList.contains('line-has-dot')) return;

        var direction = getActiveLineDirection(line);
        var isTop = direction === 'top';
        var isBottom = direction === 'bottom';
        var isLeft = direction === 'left';
        var isRight = direction === 'right';
        var isHorizontal = isTop || isBottom;
        var isVertical = isLeft || isRight;

        if (!isHorizontal && !isVertical) return;

        var marker = document.createElement('span');
        marker.setAttribute('aria-hidden', 'true');
        marker.style.position = 'absolute';
        marker.style.display = 'block';
        marker.style.visibility = 'hidden';
        marker.style.pointerEvents = 'none';
        marker.style.zIndex = '-1';
        marker.style.transform = 'translate(var(--x, 0), var(--y, 0))';

        if (isHorizontal) {
            marker.style.left = 'var(--left, 0)';
            marker.style.right = 'var(--right, 0)';
            marker.style.width = 'var(--width, auto)';
            marker.style.height = 'var(--size, 1px)';
            marker.style.top = isTop ? 'var(--top, 0)' : 'auto';
            marker.style.bottom = isBottom ? 'var(--bottom, 0)' : 'auto';
            marker.style.transformOrigin = 'var(--origin, left center)';
        } else {
            marker.style.top = 'var(--top, 0)';
            marker.style.bottom = 'var(--bottom, 0)';
            marker.style.width = 'var(--size, 1px)';
            marker.style.height = 'var(--height, auto)';
            marker.style.left = isLeft ? 'var(--left, 0)' : 'auto';
            marker.style.right = isRight ? 'var(--right, 0)' : 'auto';
            marker.style.transformOrigin = 'var(--origin, center top)';
        }

        line.appendChild(marker);

        var lineRect = line.getBoundingClientRect();
        var markerRect = marker.getBoundingClientRect();

        marker.remove();

        if (!markerRect.width && !markerRect.height) return;

        var lineSize = parseFloat(getLineVar(line, '--size')) || 1;
        var halfSize = lineSize / 2;

        var centerX;
        var centerY;

        if (side === 'left') {
            centerX = markerRect.left + halfSize;
            centerY = markerRect.top + markerRect.height / 2;
        } else if (side === 'right') {
            centerX = markerRect.right - halfSize;
            centerY = markerRect.top + markerRect.height / 2;
        } else if (side === 'top') {
            centerX = markerRect.left + markerRect.width / 2;
            centerY = markerRect.top + halfSize;
        } else if (side === 'bottom') {
            centerX = markerRect.left + markerRect.width / 2;
            centerY = markerRect.bottom - halfSize;
        } else {
            return;
        }

        setDotVar(line, '--dot-left', (centerX - lineRect.left) + 'px');
        setDotVar(line, '--dot-top', (centerY - lineRect.top) + 'px');
        setDotVar(line, '--dot-right', 'auto');
        setDotVar(line, '--dot-bottom', 'auto');
        setDotVar(line, '--dot-x', '-50%');
        setDotVar(line, '--dot-y', '-50%');
    }

    function initLineReveal() {
        var lines = document.querySelectorAll(LINE_SELECTOR);
        if (!lines.length) return;
        var resizeTimer;

        if (!('IntersectionObserver' in window)) {
            lines.forEach(function(line) {
                applyLineSettings(line);
                line.classList.add('is-visible');
            });
            return;
        }

        lines.forEach(function(line) {
            if (line.dataset.cmLineRevealInitialized === 'true') return;
            line.dataset.cmLineRevealInitialized = 'true';
            applyLineSettings(line);

            var rootMargin = line.getAttribute('data-line-root-margin') || '0px 0px -10% 0px';
            var threshold = parseFloat(line.getAttribute('data-line-threshold') || '0.15');
            var repeat = line.getAttribute('data-line-repeat') === 'true';

            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        if (!repeat) {
                            observer.unobserve(entry.target);
                        }
                    } else if (repeat) {
                        entry.target.classList.remove('is-visible');
                    }
                });
            }, {
                root: null,
                rootMargin: rootMargin,
                threshold: threshold
            });

            observer.observe(line);
        });

        // Dot positions are resolved to px, so re-align them whenever a line's
        // own box changes size (e.g. AJAX pagination swaps the news list).
        if ('ResizeObserver' in window) {
            var pendingLines = new Set();
            var pendingFrame = null;

            var sizeObserver = new ResizeObserver(function(entries) {
                entries.forEach(function(entry) {
                    var line = entry.target;
                    var size = Math.round(entry.contentRect.width) + 'x' + Math.round(entry.contentRect.height);
                    // The first callback only reports the initial size.
                    if (line.dataset.cmLineSize && line.dataset.cmLineSize !== size) {
                        pendingLines.add(line);
                    }
                    line.dataset.cmLineSize = size;
                });

                if (!pendingLines.size || pendingFrame) return;
                pendingFrame = requestAnimationFrame(function() {
                    pendingFrame = null;
                    pendingLines.forEach(function(line) {
                        if (line.classList.contains('line-has-dot')) applyLineSettings(line);
                    });
                    pendingLines.clear();
                });
            });

            lines.forEach(function(line) {
                if (line.dataset.cmLineSizeObserved === 'true') return;
                line.dataset.cmLineSizeObserved = 'true';
                sizeObserver.observe(line);
            });
        }

        var lastViewportWidth = window.innerWidth;

        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                // Mobile browsers fire "resize" when the address bar shows/hides
                // while scrolling. Only the height changes in that case, so skip
                // it; otherwise dots get re-positioned and jump on every scroll.
                if (window.innerWidth === lastViewportWidth) return;
                lastViewportWidth = window.innerWidth;

                lines.forEach(applyLineSettings);
            }, 120);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLineReveal);
    } else {
        initLineReveal();
    }

    window.cmInitLineReveal = initLineReveal;


    /// fix model sroll conflict Lenis
    document.querySelectorAll('.ct-modal').forEach(function (modal) {
        modal.setAttribute('data-lenis-prevent', '');
    });
})();


// ==============================================
// Modal Video Autoplay Fix
// ==============================================
// Oxygen hideModal() only pauses videos without resetting state.
// showModal() has no logic to replay them. autoplay attr only fires on initial parse.
// Fix: observe .oxy-modal-backdrop class changes → restart videos when modal reopens.
(function() {
    'use strict';

    if (!('MutationObserver' in window)) return;

    var modalBackdrops = document.querySelectorAll('.oxy-modal-backdrop');
    if (!modalBackdrops.length) return;

    modalBackdrops.forEach(function(backdrop) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName !== 'class') return;
                if (!backdrop.classList.contains('live')) return;

                var modal = backdrop.querySelector('.ct-modal');
                if (!modal) return;

                modal.querySelectorAll('video').forEach(function(video) {
                    video.currentTime = 0;
                    var p = video.play();
                    if (p !== undefined) p.catch(function() {});
                });
            });
        });

        observer.observe(backdrop, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
})();


// Sticky header
(function () {
    var header = document.querySelector('.header-sticky');

    if (!header) {
        return;
    }

    var stickyTop = header.offsetTop + 63;
    var lastScrollY = window.scrollY || window.pageYOffset;

    function onScroll(scrollY) {
        if (scrollY >= stickyTop) {
            header.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
        }

        if (scrollY > lastScrollY && scrollY >= stickyTop) {
            header.classList.add('is-hidden');
        } else {
            header.classList.remove('is-hidden');
        }

        lastScrollY = Math.max(scrollY, 0);
    }

    if (window.cmLenis && typeof window.cmLenis.on === 'function') {
        window.cmLenis.on('scroll', function (e) {
            var y = typeof e.scroll === 'number' ? e.scroll : window.scrollY;
            onScroll(y);
        });
    } else {
        window.addEventListener('scroll', function () {
            onScroll(window.scrollY || window.pageYOffset);
        });
    }
})();
